import { useFetchFeatureConfiguration } from './useFetchFeatureConfiguration';
import useFetchLeadSourcesOptions from './useFetchLeadSourceOptions';
import useFetchLeadStageOptions from './useFetchLeadStageOptions';
import { useFetchSalesGroup } from './useFetchSalesGroup';
import { useFetchTags } from './useFetchTags';
import { useFetchTenantFeatureConfiguration } from './useFetchTenantFeatureConfiguration';
import { useFetchTenantInfo } from './useFetchTenantInfo';

const useFetchInitialConfigData = ({ skip = true }: { skip?: boolean } = {}) => {
  useFetchTenantInfo({ skip });
  useFetchFeatureConfiguration({ skip });
  useFetchTenantFeatureConfiguration({ skip });
  useFetchLeadStageOptions({ skip });
  useFetchLeadSourcesOptions({ skip });
  useFetchSalesGroup({ skip });
  useFetchTags({ skip });
};

export default useFetchInitialConfigData;
